import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';
import { DefaultComponentVariantType, InputVariantType } from 'src/domains/layouts/config/features/types';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { css, SerializedStyles } from '@emotion/react';

export const CombinationName = withConfig(theme => styled('div', { label: 'CombinationName' })`
    font-size: ${theme.star.fontSize.xRegular};
    font-weight: ${theme.star.fontWeight.medium};
    line-height: 1.3;
    margin: 0 4px 0 0;
    padding-bottom: 10px;
    text-align: left;
`);

type InputWrapperPropsType = {
    variant: typeof InputVariantType[keyof typeof InputVariantType];
    betslipVariant: DefaultComponentVariantType | null; 
}

const setInputWrapper = (variant: DefaultComponentVariantType| null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            gap: ${theme.star.gap.xSmall};
            height: 36px;
        `;
    }
    return css`
        background-color: ${theme.star.betslipGeneral.bgColorSecondary};
        height: 40px;
    `;
};

export const InputWrapper = withConfig(theme => styled('div', { label: 'InputWrapper' })<InputWrapperPropsType>`
    ${({ betslipVariant }): SerializedStyles => setInputWrapper(betslipVariant, theme)}
    display: flex;
    border-radius: ${({ variant }): string => variant === InputVariantType.SECONDARY ? '4px': '0'};
    overflow: hidden;
`);

export const ReturnsWrapper = styled('div', { label: 'ReturnsWrapper' })`
    display: flex;
    justify-content: space-between;
    margin-top: 8px;
`;

export const ReturnWrapper = withConfig(theme => styled('div', { label: 'ReturnWrapper' })`
    color: ${theme.star.betslipSelectionList.txtColor};
    font-size: ${theme.star.fontSize.xSmall};
    text-align: left;
    display: flex;
    align-items: center;
    line-height: 1.4;
`);

interface ReturnValuePropsType {
    variant: DefaultComponentVariantType | null;
}

const setReturnValue = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            font-size: ${theme.star.fontSize.small};
        `;
    }
    return css`
        font-size: ${theme.star.fontSize.xRegular};
        line-height: 1.43;
    `;
};

export const ReturnValue = withConfig(theme => styled('span', { label: 'ReturnValue' })<ReturnValuePropsType>`
    ${({ variant }): SerializedStyles => setReturnValue(variant, theme)}
    color: ${theme.star.betslipSelectionList.txtColorTertiary};
    font-weight: ${theme.star.fontWeight.bold};
    margin-left: 4px;
`);
